import React from 'react'
import Theme from '../theme'

const useLineColors = () => {
  const { theme } = React.useContext(Theme)
  return theme.isPl2k ? theme.palette.pl2kBlack : theme.palette.ownership
}

export default useLineColors